import { yoga } from "../layoutEngine/yoga";
import { BASE_Z_INDEX } from "./componentConstants";
import type { ComponentLayoutValues } from "./coreComponents.types";

export const coreComponentCommon = () => {
  const yogaNode = yoga.createNode();
  let isCulled = false;
  let layoutValues: ComponentLayoutValues = Object.freeze({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    offsetX: 0,
    offsetY: 0,
    x: 0,
    y: 0,
    zIndex: BASE_Z_INDEX
  });

  return {
    yogaNode,
    isCulled: () => isCulled,
    setCulled: (culled: boolean) => {
      if (culled !== isCulled) {
        isCulled = culled;
        return true;
      }
      return false;
    },
    getLayoutValues: () => layoutValues,
    setLayoutValues: (props: Omit<ComponentLayoutValues, "x" | "y">) => {
      layoutValues = Object.freeze({
        ...props,
        x: props.left + props.offsetX,
        y: props.top + props.offsetY
      });
    },
    getZIndex: () => layoutValues.zIndex
  };
};
